import { createContext, useContext, useEffect, useState } from "react";
import appApi from "../api/app/appApi";
import { AppContext as AppContextModel } from "../api/quote/types";

interface AppContextType extends AppContextModel {}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [context, setContext] = useState<AppContextType>({} as AppContextType);

    useEffect(() => {
        const init = async () => {
            const appCtx = await appApi.getAppContext();
            setContext(appCtx);
        };

        init();
    }, []);

    return (
        <AppContext.Provider value={context}>
            {children}
        </AppContext.Provider>
    );
};

export function useAppContext(): AppContextType {
    const ctx = useContext(AppContext);

    if (ctx === undefined) {
        throw new Error("useAppContext must be used inside an AppContextProvider");
    }

    return ctx;
}
